import React from "react";
import { Input, Button } from "antd";
import { KeyOutlined, LockOutlined } from "@ant-design/icons";

interface Step2Props {
  otp: string;
  setOtp: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  onSubmit: () => void;
  loading: boolean;
  onRequestNewOtp: () => void;
}

export const Step2: React.FC<Step2Props> = ({
  otp,
  setOtp,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  onSubmit,
  loading,
  onRequestNewOtp,
}) => {
  return (
    <div>
      <div className="mb-4">
        <Input
          autoFocus
          size="middle"
          value={otp}
          placeholder="6-Digit OTP"
          onChange={(e) => setOtp(e.target.value)}
          prefix={<KeyOutlined />}
        />
      </div>

      <div className="mb-4">
        <Input.Password
          size="middle"
          value={password}
          placeholder="New Password"
          prefix={<LockOutlined />}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <Input.Password
          size="middle"
          value={confirmPassword}
          placeholder="Confirm New Password"
          prefix={<LockOutlined />}
          onChange={(e) => setConfirmPassword(e.target.value)}
          status={
            confirmPassword && password !== confirmPassword ? "error" : ""
          }
        />
        {confirmPassword && password !== confirmPassword && (
          <p className="text-red-500 text-end text-xs mt-1">
            Passwords do not match
          </p>
        )}
      </div>

      <div className="flex justify-between items-center mb-6">
        <Button
          type="link"
          className="p-0 text-xs text-blue-600"
          onClick={onRequestNewOtp}
        >
          Request New OTP
        </Button>
      </div>

      <Button
        type="primary"
        block
        size="middle"
        loading={loading}
        onClick={onSubmit}
        disabled={!otp || !password || password !== confirmPassword}
      >
        Reset Password
      </Button>
    </div>
  );
};
